import React, { FC } from "react";

interface PropsNormalContainer {}

const NormalContainer: FC<PropsNormalContainer> = props => {
   return <>{props.children}</>;
};

export default NormalContainer;
